module.exports = "<simple-header></simple-header>\n\n<div class=\"app-body\">\n  \n\n  <!-- Main content -->\n  <main class=\"main\">\n    <router-outlet></router-outlet>\n  </main>\n</div>\n\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/simple-layout/simple-layout.component.html
// module id = ../../../../../src/app/layouts/simple-layout/simple-layout.component.html
// module chunks = 6